import ClaimPremadeButton from "./ClaimPremadeButton";

export default ClaimPremadeButton;
export { ClaimPremadeButton as ClaimPremadeDialog };
